module.exports = __webpack_public_path__ + "b1156355de9691d768df19a8a2b44da4.svg";